import moment from 'moment';

export class BusinessDateMomentService {
  constructor(date) {
    this.date = moment(date);
  }

  businessDiff(param, relative) {
    const d1 = this.date.clone();
    const d2 = moment(param).clone();
    const positive = d1 >= d2;
    const start = d1 < d2 ? d1 : d2;
    const end = d2 > d1 ? d2 : d1;

    let daysBetween = 0;

    if (start.format('DD/MM/YYYY') === end.format('DD/MM/YYYY')) {
      return daysBetween;
    }

    while (start < end) {
      if (this.isBusinessDay(start)) {
        daysBetween++;
      }
      start.add(1, 'd');
    }

    if (relative) {
      return positive ? daysBetween : -daysBetween;
    }

    return daysBetween;
  }

  businessAdd(number, period = 'days') {
    const day = this.date.clone();
    if (!day.isValid()) {
      return day;
    }

    const signal = number < 0 ? -1 : 1;
    let remaining = Math.abs(Math.round(number));

    while (remaining > 0) {
      day.add(signal, period);
      if (this.isBusinessDay(day)) {
        remaining--;
      }
    }

    return day;
  }

  businessSubtract(number, period) {
    return this.businessAdd(-number, period);
  }

  isBusinessDay(date) {
    const locale = date.localeData();
    const defaultWorkingWeekdays = [1, 2, 3, 4, 5];
    const workingWeekdays = locale._workingWeekdays || defaultWorkingWeekdays;

    return !this.isHoliday(date) && workingWeekdays.includes(date.day());
  }

  isHoliday(date) {
    const locale = date.localeData();

    if (locale._holidays && locale._holidays.includes(date.format(locale._holidayFormat))) {
      return true;
    }

    if (locale.holiday && locale.holiday(date)) {
      return true;
    }

    return false;
  }
}
